import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { IDataUploadComment } from "../../../interfaces/IDataUploadComment";
import { NewIDataUploadItem } from "../../../interfaces/IDataUploadItem";
import { IForm } from "../../../interfaces/IForm";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const editFormFinishCL = async (
  dataForm?: IForm,
  uploadRealization?: NewIDataUploadItem[],
  requestID?: string,
  requestStatusID?: string,
  crrNumber?: string,
  actionButtonClick?: string,
  emailType?: string
) => {
  function convertData(inputData: NewIDataUploadItem[]) {
    return inputData.reduce((acc: any[], curr) => {
      const files = curr.files.map((file) => ({
        title: curr.title,
        fileType: curr.fileType,
        ...file,
      }));
      return [...acc, ...files];
    }, []);
  }

  const realization = convertData(uploadRealization || []);

  const data = HttpService.post(
    ApiService.alesaForm.editFormCorporateLegalFinish,
    JSON.stringify({
      CrrNumber: crrNumber,
      StartDateString: dataForm?.startDatePeriod,
      EndDateString: dataForm?.endDatePeriod,
      RequestDate: dataForm?.requestDate,
      POADate: dataForm?.dateOfPower,
      BinusianID: dataForm?.binusianID,
      BinusianName: dataForm?.binusianName,
      TitleAgreement: dataForm?.titleAgreement,
      Counterpart: dataForm?.counterPart,
      Signer: `${dataForm?.signer?.binusianIDEmail}#${dataForm?.signer?.name}`,
      DocumentTypeID: dataForm?.documentType,
      Area: dataForm?.area,
      DetailArea: dataForm?.address,
      RequestID: requestID,
      RequestTypeID: dataForm?.requestType,
      Delegatee:
        dataForm?.delegatee != null
          ? `${dataForm?.delegatee?.binusianIDEmail}#${dataForm?.delegatee?.name}`
          : dataForm?.delegatee,
      Substitutor:
        dataForm?.substitutor != null
          ? `${dataForm?.substitutor?.binusianIDEmail}#${dataForm?.substitutor?.name}`
          : dataForm?.substitutor,
      RequestStatusID: requestStatusID,
      ListFileUploadDocumentRealization: realization,
      ActionClick: actionButtonClick,
      NoPowerAttorney: dataForm?.noPowerAttorney,
      NoSubstitutor: dataForm?.noSubstitutor,
      EmailType: emailType,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadSingleFile = async (
  documentName?: string,
  category?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadSingleFile,
    JSON.stringify({
      DocumentName: documentName,
      Category: category,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadFileComment = async (
  commentID?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadFileComment,
    JSON.stringify({
      CommentID: commentID,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getSharepointToken = async () => {
  const data = HttpService.get(ApiService.alesaForm.getSharepointToken);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const cancelPendingReject = async (
  requestID?: string,
  binusianID?: string,
  comment?: string,
  commentDocument?: IDataUploadComment,
  requestStatusID?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.pendingRejectCancelALESA,
    JSON.stringify({
      RequestID: requestID,
      BinusianID: binusianID,
      Comment: comment,
      FileCommentDocument: commentDocument,
      RequestStatusID: requestStatusID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const resendEmailFinishedForm = async (
  requestID?: string,
  emailType?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.resendEmailFinishedForm,
    JSON.stringify({
      RequestID: requestID,
      EmailType: emailType,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
